<template>
  <div id="right-comp">
    <div class="right-common-block">
      <div class="right-common-title">
        热搜资讯
      </div>
      <div class="rszx-list-wrap">
        <div class="rszx-cell flex-wrapper" v-for="(item, index) in rszxList" :key="index">
          <i>{{ index+1 }}</i>
          <a href="javascript:void(0)" @click="jumpDetail(item.first_type,item.id)">{{ item.title }}</a>
        </div>
      </div>
    </div>

    <div class="right-common-block">
      <div class="right-common-title">
        精彩课堂
      </div>
      <div class="jckt-list-wrap">
        <a class="jckt-cell flex-wrapper" v-for="(item, index) in jcktList" :key="index" href="javascript:void(0)" @click="jumpDetail(item.first_type,item.id)">
          <img :src="item.image_list[0]" alt="">
          <div class="jckt-cell-right">
            <p class="jckt-cell-title">
              {{ item.title }}
            </p>
          </div>
        </a>
      </div>
    </div>

    <div class="right-common-block">
      <div class="right-common-title">
        投教活动
      </div>
      <div class="right-tjhd-wrap">
        <a class="tjhd-cell" v-for="(item,index) in tjhdList" :key="index" href="javascript:void(0)" @click="jumpDetail(item.first_type,item.id)">
          <img :src="item.image_list[0]" alt="" />
          <p class="tjhd-cell-title">{{ item.title }}</p>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import UTILS from '../common/utils'
import { getHotNews, getExcellentClass, getNewsList } from '../service/api'
export default {
  name: 'commonRight',
  data(){
    return{
      rszxList:[],
      jcktList: [],
      tjhdList:[]
    }
  },
  mounted() {
    getHotNews({
      page_size:10,
      page_num:1
    }).then(res => {
      this.rszxList = res.data.data.data_list
    })

    getExcellentClass({
      page_size:10,
      page_num:1
    }).then(res => {
        let _arr = []
        if(res.data.data.data_list && res.data.data.data_list.length){
          for(let i=4;i<8;i++) {
            _arr.push(res.data.data.data_list[i])
          }
        }
        this.jcktList = _arr
      })

    // 获取投教活动
    getNewsList({
      api_type: 3618533814,
      page_size: 2,
      page_num: 1
    }).then(res => {
      this.tjhdList = res.data.data.data_list
    })
    
  },
  methods:{
    jumpDetail(type,id){
      UTILS.fixJumpDetail(type,id)
    }
  }
}
</script>

<style lang="less">
@import '../common/global.less';
#right-comp{
  .right-common-block{
    margin-bottom:40px;
    .right-common-title{
      font-size:20px;
      font-weight: bold;
      display: flex;
      align-items: center;
      &::before{
        content: '';
        width:4px;
        height:20px;
        background-color: #376ed2;
        margin-right: 10px;
      }
    }
    .rszx-list-wrap{
      .rszx-cell{
        .flex-center-layout();
        margin:20px 0;
        &:nth-child(1){
          i{
            background-color:#ED0B0B;
          }
        }
        &:nth-child(2){
          i{
            background-color:#F44D4D;
          }
        }
        &:nth-child(3){
          i{
            background-color:#F99C9C;
          }
        }
        i{
          color:#fff;
          font-size:12px;
          width:20px;
          height:20px;
          background-color: #999;
          margin-right:12px;
          .flex-center-layout();
          
          
        }
        a{
          color:#212121;
          font-size:16px;
          flex:1;
          line-height: 20px;
          .text-lines(1);
        }
      }
    }
    .jckt-list-wrap{
      margin-top: 25px;
      .jckt-cell{
        margin-bottom: 20px;
        &:hover{
          .jckt-cell-right{
            color:#2769e4;
          }
        }
        img{
          width:172px;
          height:95px;
          margin-right: 14px;
        }
        .jckt-cell-right{
          flex:1;
          .jckt-cell-title{
            font-size:16px;
            .text-lines(3);
          }
        }
        
      }
    }
    .right-tjhd-wrap{
      .tjhd-cell{
        margin-top:25px;
        display: block;
        &:hover{
          .tjhd-cell-title{
            color:#2769e4;
          }
        }
        img{
          width:100%;
          height:220px;
        }
        .tjhd-cell-title{
          font-size:18px;
          color:#212121;
          .text-lines(1);
          cursor: pointer;
          font-weight: bold;
          margin-top:15px;
        }
      }
    }
  }
}

</style>